<template>
  <Modal
    ref="listedProductWarningModalRef"
    content-id="listed-product-modal"
    :showIcon="true"
    :clickToClose="true"
    @onNegativeActionClick="closeListedProductWarningModal"
    @onPositiveActionClick="goToProductListNewTab"
    negativeActionText="Arama Sayfasına Dön"
    positiveActionText="Ürün Listesine Git"
    :modalStyle="{ width: '460px',height:'334px' }"
    class="listed-product-modal"
    type="info"
  >
    <template v-slot:body style="gap: 18px;">
      <h3 class="listed-product-modal-title">
      Bu ürün, listenizde mevcut.
      </h3>
      <p class="listed-product-modal-text">
      Bu ürün tek varyantlı olarak <br>
      <span class="highlight">{{ pimsId  }} katalog kodu </span> ile listenizde bulunuyor.
      </p>
      <p class="listed-product-modal-text">Dilerseniz listenizden ürünü inceleyebilirsiniz.</p>
    </template>
  </Modal>
</template>
<script setup>
import { ref } from "vue";
import { Modal } from '@n11/so-ui-components';

const props = defineProps({
  pimsId: {
    type: [Number, String, Object],
    required: false,
    default: '',
  }
});

const listedProductWarningModalRef = ref();

const openListedProductWarningModal = () => listedProductWarningModalRef.value.openModal();

const closeListedProductWarningModal = () => listedProductWarningModalRef.value.hiddenModal();

const goToProductListNewTab = () => {
  window.open('/selleroffice/v2/product/products', '_blank');
};

defineExpose({
  openListedProductWarningModal,
})

</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

#listed-product-modal {
  .listed-product-modal-title {
    color: $black;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 26px;
    letter-spacing: -0.2px;
  }

  .listed-product-modal-text{
    color: $colorN80;
    text-align: center;
    font-size: 16px;
    font-weight: 400;
    font-style: normal;
    line-height: 24px;
    letter-spacing: -0.05px;
    margin-bottom: 4px;

    .highlight{
      font-weight: 600;
    }
  }
}

</style>